var _rect, _rect2, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcoDelete(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    rx: 10,
    transform: "matrix(-1 0 0 1 20 0.751953)",
    fill: "#F6F6F6"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 10,
    height: 10,
    transform: "translate(5 5.75195)",
    fill: "#F6F6F6"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.7522 14.5597L10.6925 11.5L13.7522 8.44026C14.0826 8.10992 14.0826 7.57809 13.7522 7.24775C13.4219 6.91742 12.8901 6.91742 12.5597 7.24775L9.5 10.3075L6.44026 7.24775C6.10992 6.91742 5.57809 6.91742 5.24775 7.24775C4.91742 7.57809 4.91742 8.10992 5.24775 8.44026L8.3075 11.5L5.24775 14.5597C4.91742 14.8901 4.91742 15.4219 5.24775 15.7522C5.57809 16.0826 6.10992 16.0826 6.44026 15.7522L9.5 12.6925L12.5597 15.7522C12.8901 16.0826 13.4219 16.0826 13.7522 15.7522C14.0802 15.4219 14.0802 14.8877 13.7522 14.5597Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoDelete);
export default __webpack_public_path__ + "static/media/ico_delete.053be8fb94791c71eb275098ac21d715.svg";
export { ForwardRef as ReactComponent };